var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sidebar-subtitle",
      class: { activeSubTab: _vm.activeSubTab, disabled: _vm.disabled },
      on: { click: _vm.toggleSubMenu }
    },
    [
      !_vm.item.show
        ? _c(
            "div",
            { staticClass: "management-submenu-item" },
            [
              _vm._v("\n    " + _vm._s(_vm.item.name) + "\n    "),
              _vm.item.dev
                ? _c("dev-tag", {
                    style: {
                      zoom: "80%",
                      "margin-left": "20px",
                      "font-weight": 300
                    },
                    attrs: { position: "relative" }
                  })
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-43e662f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-43e662f5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management/Sidebar/SidebarSubmenuItem.vue
// module id = null
// module chunks = 